// extracted by mini-css-extract-plugin
export default {"container":"InformationalBanner_container__lrZmt","text":"InformationalBanner_text__MviiI","title":"InformationalBanner_title__PkhfT","icon":"InformationalBanner_icon__4te1V"};